<template>
  <header
    class="l-header header"
    ref="header"
    id="header">
    <nav class="navbar columns is-gapless">
      <div class="navbar-brand column is-narrow logo">
        <!-- 198*164 -->
        <router-link to="/">
          <img
            :src="$configs.LOGO_MAIN"
            width="72"
            alt="Vadimm">
        </router-link>
      </div>
      <!--<div class="navbar-brand column is-narrow logo logo--bis is-border-bottom is-border-left">
        <router-link to="/">
          <img src="img/chartes-clients/ok-immo/logo-menu--paysage.jpg" height="81" alt="Vadimm paysage">
        </router-link>
      </div>-->

      <div class="navbar-menu is-border-bottom">
        <div class="columns is-gapless w100">
          <div class="navbar-start columns column is-gapless is-3 is-2-widescreen">
            <!--Info Si : (logo--bis) ? is-4 is-3-widescreen : is-3 is-2-widescreen -->
            <div
              class="column columns is-centered is-vcentered is-border-right dropdown is-left header-notifications"
              @mouseleave="closeNotification()">
              <!-- is-hoverable -->
              <a
                class="dropdown-trigger"
                @click="toggleNotification()">
                <div
                  v-if="runningNotifications.length > 0"
                  class="badge has-badge-rounded has-badge-medium has-badge-notification"
                  :data-badge="runningNotifications.length">
                  <span class="icon is-medium">
                    <i class="fal fa-lg fa-bell"></i>
                  </span>
                </div>
                <div v-else>
                  <span class="icon is-large">
                    <i class="fal fa-lg fa-bell"></i>
                  </span>
                </div>
              </a>
              <div
                v-if="$route.name !== 'EventList' && displayNotification"
                class="dropdown-menu is-block"
                id="dropdown-menu"
                role="menu"
                @mouseenter="openNotification()">
                <div class="dropdown-content">
                  <div
                    v-if="events.length > 0"
                    class="header-notifications-items">
                    <template v-for="(event, index) in timeline">
                      <div
                        v-if="event.showDayLabel"
                        :key="event.event.pk + Date.now() + 'show-day'"
                        :class="{'is-border-top' : index !== 0}"
                        class="column has-background-light is-padding-top-xsmall is-padding-bottom-xsmall il-padding-lest-small is-border-bottom is-size-7 has-text-grey is-sticky-0 is-zindex-2">
                        <strong>
                          {{ event.date | dtFormat('dddd') | cap }} {{ event.date | dtFormat('DD') }} {{ event.date | dtFormat('MMMM') | cap }}
                        </strong>
                      </div>
                      <line-notification
                        v-if="event.event.link"
                        :href="event.event.link"
                        :key="event.event.pk + Date.now()"
                        class="is-border-bottom"
                        @removeEvent="removeEvent"
                        @updateEvent="updateEvent"
                        :event="event.event"
                        :since="event.event.created_on | timeDelta"
                        :title="event.event.title"
                        :description="event.event.description"></line-notification>
                      <line-notification
                        v-else
                        :key="event.event.pk + Date.now()"
                        class="is-border-bottom"
                        @removeEvent="removeEvent"
                        @updateEvent="updateEvent"
                        :event="event.event"
                        :since="event.event.created_on | timeDelta"
                        :title="event.event.title"
                        :description="event.event.description"></line-notification>
                    </template>
                  </div>
                  <div
                    v-else
                    class="is-padding">
                    <i class="is-size-6">Aucune nouvelle notification.</i>
                  </div>
                  <div class="header-notifications-actions is-clipped">
                    <div class="columns has-background-primary">
                      <div
                        v-if="events.length > 0"
                        class="column">
                        <div
                          @click="patchAllEvents"
                          class="button is-primary is-small is-fullwidth">
                          <span class="icon is-small"><i class="fas fa-check-circle"></i></span>
                          <span>Tout marquer comme lu</span>
                        </div>
                      </div>
                      <div class="column">
                        <a
                          href="#"
                          @click="openUserNotificationQuickview()"
                          class="button is-primary is-small is-fullwidth">
                          <span class="icon is-small"><i class="fas fa-bells"></i></span>
                          <span>Gérer vos notifications</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column columns is-centered  is-vcentered is-border-right">
              <router-link :to="{name: 'OptionList'}">
                <!-- <div v-if="runningOptions.length >= 1" class="has-badge-medium has-badge-notification has-badge-rounded"
                     :data-badge='runningOptions.length'>
                  <span class="icon is-large">
                    <i class="fal fa-lg fa-flag"></i>
                  </span>
                </div> -->
                <div>
                  <span class="icon is-large">
                    <i class="fal fa-lg fa-user-clock"></i>
                  </span>
                </div>
              </router-link>
            </div>
            <div
              v-if="!canAddUsers && isAdmin && !isPromoteur"
              class="column columns is-centered  is-vcentered is-border-right">
              <router-link :to="{name: 'RelationsList'}">
                <div
                  v-if="runningRelationLength"
                  class="has-badge-medium has-badge-notification has-badge-rounded"
                  :data-badge="runningRelationLength">
                  <span class="icon is-large">
                    <i class="fal fa-lg fa-handshake-alt"></i>
                  </span>
                </div>
                <div v-else>
                  <span class="icon is-large">
                    <i class="fal fa-lg fa-handshake-alt"></i>
                  </span>
                </div>
              </router-link>
            </div>
          </div>
          <div class="navbar-content header-searchinput has-background-light is-border-right">
            <div
              class="field is-grouped is-padding-right w100"
              :class="{'is-degrad-info': searchValue && searchValue.length}">
              <form
                @submit.prevent.stop="search(searchValue)"
                class="is-expanded control">
                <input
                  id="recherche"
                  name="recherche"
                  v-model="searchValue"
                  class="input is-large is-size-3"
                  @input="search"
                  :class="{'has-text-white': searchValue && searchValue.length}"
                  type="text"
                  v-validate="'required|min:2'"
                  placeholder="Saisir un ou plusieurs mots clés">
              </form>
              <p class="control">
                <a
                  v-if="searchValue && searchValue.length > 0"
                  @click.prevent.stop="cancelSearch"
                  class="has-text-white">
                  <i class="fa-lg fal fa-times"></i>
                </a>
                <a
                  v-else
                  @click.prevent.stop="search(searchValue)"><i class="fa-lg fal fa-search"></i></a>
              </p>
            </div>
            <search-panel
              v-if="isLog"
              @cancelSearch="cancelSearch"></search-panel>
          </div><!-- /.navbar-content header-searchinput -->

          <div
            class="navbar-end column is-narrow dropdown is-right"
            @mouseleave="closeMenu()">
            <div
              class="dropdown-trigger has-cursor-pointer columns is-gapless is-minH100"
              id="navbarDropdownMenuActions"
              @click="toggleMenu()">
              <div
                class="column is-self-centered is-radius-large"
                aria-controls="dropdown-userLogMenu">
                <!-- is-border -->
                <span class="vadPicto is-large">
                  <img
                    key="currentUserPicture"
                    class="veryFastAnimation"
                    v-if="currentUser.picture"
                    :src="currentUser.picture | avatarHeader"
                    width="56"
                    height="56">
                  <img
                    key="default"
                    class="veryFastAnimation"
                    v-else
                    src="/img/placeholder/default-avatar.jpg"
                    width="40"
                    height="40">
                </span>
                <div
                  class="has-text-primary is-padding-left-xsmall is-padding-right-xxsmall is-inline-block"
                  style="line-height: 1.2">
                  <span>{{ currentUser.account.name }}</span><br>
                  <b>{{ currentUser.last_name }} {{ currentUser.first_name }}</b>
                </div>
                <!-- <span class="icon has-text-grey"><i class="fas fa-chevron-down"></i></span> -->
              </div>
              <div class="column is-narrow is-flex is-border-left">
                <button class="button is-medium is-light is-minW76p is-minH100">
                  <span class="icon is-large has-text-grey"><i class="far fa-bars"></i></span>
                </button>
              </div>
            </div>
            <div
              class="dropdown-menu dropdown-menu-bg-light is-block"
              id="dropdown-userLogMenu"
              role="menu"
              v-if="displayMenu"
              @mouseenter="openMenu()">
              <div class="dropdown-content is-paddingless-bottom">
                <router-link
                  id="navbarDropdownItemInfos"
                  :to="{name: 'Profil', params: {id: currentUser.pk}}"
                  class="dropdown-item">
                  <span class="icon is-medium"><i class="fas fa-user"></i></span><b>Mon compte</b>
                </router-link>
                <router-link
                  v-if="isAdmin"
                  id="navbarDropdownItemInfos"
                  :to="{ name: 'ProfilCompanyInfo', params: { id: currentUser.account.pk }}"
                  class="dropdown-item">
                  <span class="icon is-medium"><i class="fas fa-cog"></i></span><b>Paramètre compte</b>
                </router-link>
                <!-- <router-link v-if="isFirstAdmin" class="dropdown-item"
                   :to="{name: 'myCompany', params: {id: currentUser.account.pk}}">
                  <span class="icon is-medium"><i class="fas fa-address-card"></i></span><b>Modifier infos société</b>
                </router-link> -->
                <router-link
                  class="dropdown-item"
                  :to="{name: 'TicketList'}">
                  <span class="icon is-medium"><i class="fas fa-user-headset"></i></span><b>Ticket support</b>
                </router-link>
                <a
                  href="https://support.vadimm.fr/"
                  id="navbarDropdownItemLogOut"
                  target="blank"
                  class="dropdown-item"><span class="icon is-medium"><i
                    class="fas fa-question-circle"></i></span><b>Guide utilisateur</b></a>
                <a
                  @click="logout()"
                  id="navbarDropdownItemLogOut"
                  class="dropdown-item"><span class="icon is-medium"><i
                    class="fas fa-sign-out"></i></span><b>Déconnexion</b></a>
                <span class="dropdown-item is-size-7 is-border-top has-background-white is-padding-top-xxsmall is-padding-bottom-xxsmall">
                  Vadimm {{ appVersion }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import { DefaultValues, Quickview } from '@/mixins'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { concat } from 'lodash'
import { bus, EVENTS } from '@/bus'

export default {
  name: 'LayoutHeader',
  components: {
    LineNotification: () => import('@/components/notifications/LineNotification'),
    SearchPanel: () => import('@/components/layout/SearchPanel')
  },
  mixins: [Quickview, DefaultValues],
  data () {
    return {
      storageNotif: [],
      runningNotifications: [],
      searchValue: null,
      displayMenu: false,
      timerMenu: null,
      displayNotification: false,
      timerNotification: null,
      isDisableAlert: false
    }
  },
  computed: {
    ...mapState(['currentUser', 'events', 'device']),
    ...mapGetters(['sortedEvents', 'runningOptions', 'runningRelationLength', 'newEvents', 'isLog', 'isSeller', 'isAdmin', 'isPromoteur', 'isFirstAdmin', 'canAddUsers']),
    // fiveLastEvents () {
    //   return this.sortedEvents.filter(x => x.is_new).slice(0, 5)
    // },
    timeline () {
      let timeline = []
      if (this.listedEvents && this.listedEvents.length) {
        return this.listedEvents.map(x => {
          let date = moment(x.date).format('DD/MM/YYYY')
          if (timeline.includes(date) === false) {
            this.$set(x, 'showDayLabel', true)
            timeline.push(date)
          }
          return x
        })
      } else {
        return []
      }
    },
    listedEvents () {
      return this.sortedEvents.map(x => {
        return {
          event: Object.assign({}, x),
          date: x.created_on,
          showDayLabel: false
        }
      })
    },
    appVersion () {
      return process.env.npm_package_version
    }
  },
  mounted () {
    bus.$on(EVENTS.CLEAN_SEARCH_INPUT, () => {
      this.searchValue = null
    })
    bus.$on(EVENTS.CLOSE_CONTENTMAIN_OVERLAY, () => { this.cancelSearch(false) }) // On vide la recherche sans l'envoie de l'event pour eviter les boucle infinie
  },
  created () {
    this.initEvent()
    bus.$on(EVENTS.NEW_EVENT, (data) => {
      this.addEvent(data)
    })
  },
  destroyed () {
    bus.$off([EVENTS.NEW_EVENT])
  },
  methods: {
    async patchAllEvents () {
      const params = {
        is_new: false
      }
      try {
        await this.$api.axios.patch('events', params)
        this.$store.dispatch('loadEvents')
      } catch (err) {
        console.log(err)
      }
    },
    async removeAllRunningEvent () {
      for (let notif of this.storageNotif) {
        notif.seen = true
      }
      await localStorage.setItem('runningNotifications', JSON.stringify(this.storageNotif))
      this.runningNotifications = this.storageNotif.filter(x => x.seen === false)
    },
    async addEvent (event) {
      let idx = -1
      if (this.currentUser.disable_program_alert) {
        for (let alert of this.currentUser.disable_program_alert) {
          if (alert === event.details.program) {
            this.isDisableAlert = true
          }
        }
      }
      if (this.storageNotif.length > 0) {
        idx = this.storageNotif.findIndex(x => x.pk === event.pk)
      }
      if (idx < 0 && this.isDisableAlert === false) {
        let newEvent = {
          pk: event.pk,
          seen: false,
          new: event.is_new
        }
        this.storageNotif.push(newEvent)
        await localStorage.setItem('runningNotifications', JSON.stringify(this.storageNotif))
        this.runningNotifications = this.storageNotif.filter(x => x.seen === false)
      }
    },
    async initEvent () {
      let events = await this.$store.dispatch('loadEvents')
      const notificationAlreadySetting = localStorage.getItem('notificationAlreadySetting')
      let storageNotifications = localStorage.getItem('runningNotifications')
      storageNotifications = JSON.parse(storageNotifications)
      if (notificationAlreadySetting) {
        let newEvents = []
        for (let event of events) {
          const idx = storageNotifications.findIndex(x => x.pk === event.pk)
          if (idx < 0) {
            let newEvent = {
              pk: event.pk,
              seen: false,
              new: event.is_new
            }
            newEvents.push(newEvent)
          }
        }
        if (newEvents.length) {
          let concatEvent = concat(storageNotifications, newEvents)
          await localStorage.setItem('runningNotifications', JSON.stringify(concatEvent))
        }
      } else {
        localStorage.setItem('notificationAlreadySetting', true)
        let eventsTab = []
        for (let event of events) {
          let newEvent = {
            pk: event.pk,
            seen: true,
            new: event.is_new
          }
          eventsTab.push(newEvent)
        }
        if (eventsTab.length) {
          await localStorage.setItem('runningNotifications', JSON.stringify(eventsTab))
        } else {
          await localStorage.setItem('runningNotifications', [])
        }
      }
      this.storageNotif = localStorage.getItem('runningNotifications')
      this.storageNotif = JSON.parse(this.storageNotif)
      this.runningNotifications = this.storageNotif.filter(x => x.seen === false)
    },
    search () {
      bus.$emit(EVENTS.INIT_SEARCH_PANEL, this.searchValue)
      if (this.searchValue.length > 0) bus.$emit(EVENTS.OPEN_CONTENTMAIN_OVERLAY)
      else bus.$emit(EVENTS.CLOSE_CONTENTMAIN_OVERLAY)
    },
    cancelSearch (eventCloseOverlay = true) {
      this.searchValue = null
      bus.$emit(EVENTS.CLOSE_SEARCH_PANEL)
      if (eventCloseOverlay) bus.$emit(EVENTS.CLOSE_CONTENTMAIN_OVERLAY)
    },
    /** Logout and redirect to referrer if entrypoint is white label login */
    logout () {
      this.$store.commit('logout')
      window.localStorage.removeItem('token')
      const referrer = localStorage.getItem('referrer')
      if (referrer) {
        window.localStorage.removeItem('referrer')
        window.location = referrer
      } else {
        this.$router.replace({ name: 'Login' })
      }
    },
    async removeEvent (eventPk) {
      try {
        await this.$store.dispatch('removeEvent', eventPk)
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Impossible de supprimer cet evenement')
      }
    },
    async updateEvent (eventPk, payload) {
      try {
        await this.$store.dispatch('updateEvent', { eventPk, payload })
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Impossible de modifier cet evenement')
      }
    },
    closeMenu () {
      this.timerMenu = setTimeout(() => {
        this.displayMenu = false
      }, 2)
    },
    openMenu () {
      clearTimeout(this.timerMenu)
      this.displayMenu = true
    },
    toggleMenu () {
      if (this.displayMenu) this.closeMenu()
      else this.openMenu()
    },
    closeNotification () {
      this.timerNotification = setTimeout(() => {
        this.displayNotification = false
      }, 200)
      this.deleteSeenEvents()
    },
    // async deleteSeenEvents () {
    //   for (let event of this.sortedEvents) {
    //     if (!event.is_new) {
    //       await this.$store.dispatch('removeEvent', event.pk)
    //     }
    //   }
    // },
    async deleteSeenEvents () {
      try {
        await this.$api.axios.delete(`events?is_new=0`)
        this.$store.dispatch('loadEvents')
      } catch (err) {
        console.log(err)
      }
    },
    openNotification () {
      clearTimeout(this.timerNotification)
      this.displayNotification = true
    },
    toggleNotification () {
      if (this.displayNotification) {
        this.closeNotification()
      } else {
        this.openNotification()
        this.removeAllRunningEvent()
      }
    }
  }
}
</script>
